let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ODhIj")).then(() => parcelRequire('2FSSM'));